
import Vue from 'vue';
import Component from 'vue-class-component';

// Visibility and per-language text come from VUE_APP_INFO_BAR_* env variables,
// which are baked in at build time (npm run build).
const textSl = (process.env.VUE_APP_INFO_BAR_TEXT_SL || '').trim();
const textEn = (process.env.VUE_APP_INFO_BAR_TEXT_EN || '').trim();

@Component({})
export default class InfoBar extends Vue {
    // Falls back to the other language when the current one has no text.
    public get text(): string {
        return this.$i18n.locale === 'sl_SI' ? textSl || textEn : textEn || textSl;
    }

    public get isEnabled(): boolean {
        return process.env.VUE_APP_INFO_BAR_ENABLED === 'true' && this.text.length > 0;
    }
}
